import { FormGroup } from '@angular/forms';

import { FormStatus } from '../enums/form-status.enum';

export const isFormValidOrDisabled = (formGroup: FormGroup): boolean =>
	formGroup?.status === FormStatus.VALID || formGroup?.status === FormStatus.DISABLED;
